import RxQuery from 'utils/api/rxQuery/rxQuery';
import endpoints from 'utils/api/endpoints';
import { getLanguage } from 'utils/language/language';

import * as payloads from 'utils/api/payloads/omantelPortal';
const securityServicesApi = () => new RxQuery('securityServices');

export const getQualtricsToken = () => {
	return securityServicesApi()
		.setEndpoint(endpoints.securityServices.getNmfloId)
		.setCustomHeaders()
		.setHeaders('x-device-id', 'EBU')
		.disableCache();
};

export const doLoginWithOTP = (username: string, password: string, isPasswordEncryptionEnabled?: boolean) => {
	return securityServicesApi()
		.setEndpoint(endpoints.securityServices.loginWithOTP)
		.setPayload(payloads.login(username, password, getLanguage().toUpperCase(), true, isPasswordEncryptionEnabled))
		.setType('auth')
		.disableCache();
};

export const validateLoginOTP = (username: string, OTP: string) => {
	return securityServicesApi()
		.setEndpoint(endpoints.securityServices.validateLoginOTP)
		.setPayload(payloads.validateLogin(username, OTP))
		.disableCache();
};

export const getPasswordEncryptionKey = (username: string) => {
	return securityServicesApi()
		.setEndpoint(endpoints.securityServices.getPasswordEncryptionKey)
		.setPayload(payloads.passwordEncryption(username))
		.disableCache();
};
